module.exports = __webpack_public_path__ + "static/img/MATTHEW_HAYDEN.90d36d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MATTHEW_HAYDEN.jpg
// module id = g07e
// module chunks = 0